export const GROUP_CREATE_RESET = 'GROUP_CREATE_RESET'
export const GROUP_CREATE_SET_CREATED = 'GROUP_CREATE_SET_CREATED'
export const GROUP_CREATE_SET_ERROR = 'GROUP_CREATE_SET_ERROR'
export const GROUP_CREATE_SET_VIOLATIONS = 'GROUP_CREATE_SET_VIOLATIONS'
export const GROUP_CREATE_TOGGLE_LOADING = 'GROUP_CREATE_TOGGLE_LOADING'
